import { Input } from 'antd';
import { Box } from '../../../box';
import { Block } from '../../../block';
import { useTranslation } from '../../../i18n';
import { Highlighter, DragItem } from '../../component';
import styles from '../style.module.less';
import { service } from '../service';
import { usePrimaryColor } from '../../hooks';
import type { ReactElement } from 'react';
import type { TextAreaProps } from './types';

export function TextAreaDesignMode(props: TextAreaProps): ReactElement {
  const [t] = useTranslation();
  const { rgbColor } = usePrimaryColor();

  // 拖拽时显示组件
  if (props.name == null) {
    return (
      <DragItem title={props.initTitle ?? ''} />
    );
  }

  // 主题色
  const activeStyle = props.active === true ? {
    boxShadow: `${rgbColor} 0 0 3px`
  } : {};

  return (
    <Box
      className={styles.designBox}
      style={{ ...activeStyle, paddingLeft: service.getIndent(props.path) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title ?? t('TextArea')}
          keyword={props.keyword}
          className={styles.title}
          require={props.validator === 'required'}
        />
      </Box>
      <Block if={props.name != null}>
        <Box className={styles.input}>
          <Input.TextArea
            placeholder={props.textPlaceholder ?? ''}
            value={props.value}
            readOnly={true}
          />
        </Box>
      </Block>
    </Box>
  );
}
